import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate, { defaultFormatDate } from "go-core/components/Formatters/FormatDate";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { InvoiceApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	invoice: InvoiceApi;
	customFieldsConfig: CustomFieldTemplateApi[];
}

const InvoicePreviewBasicInfoCard = ({ invoice, customFieldsConfig }: Props) => {
	const { t } = useTranslation();

	return (
		<Card className="card-box">
			<Card.Body>
				<h5 className="card-title">{t("common.word.basic_info")}</h5>
				<div className="row">
					<div className="col-md-4 mt-sm-2 mt-0">
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("modules.invoice.field.invoice_type.title")}</span>
								<span>{t(`enums.invoices.calculation_type.${invoice.calculation_type}`)}</span>
							</div>
						</div>
					</div>
					<div className="col-md-4 mt-sm-2 mt-0">
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("modules.invoice.field.sale_date.title")}</span>
								<span>{FormatDate(invoice.dates.sale_date, undefined, false, defaultFormatDate)}</span>
							</div>
						</div>
					</div>
					<div className="col-md-4 mt-sm-2 mt-0">
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("modules.invoice.field.issued_at.title")}</span>
								<span>{FormatDate(invoice.dates.issue_date, undefined, false, defaultFormatDate)}</span>
							</div>
						</div>
					</div>
					<div className="col-md-4 mt-sm-2 mt-0">
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("modules.invoice.field.pay_date.title")}</span>
								<span>{FormatDate(invoice.dates.pay_date, undefined, false, defaultFormatDate)}</span>
							</div>
						</div>
					</div>
					<div className="col-md-4 mt-sm-2 mt-0">
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("modules.invoice.field.place_of_issue.title")}</span>
								<span>{invoice.place_of_issue ?? "-"}</span>
							</div>
						</div>
					</div>
					<div className="col-md-4 mt-sm-2 mt-0">
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("modules.invoice.field.issuer_person_name.title")}</span>
								<span>{invoice.issuer_person_name ?? "-"}</span>
							</div>
						</div>
					</div>
					<div className="col-md-4 mt-sm-2 mt-0">
						<div className="card-body-item">
							<div className="item-info">
								<span className="label">{t("common.word.comment.title")}</span>
								<span>{invoice.notes ?? "-"}</span>
							</div>
						</div>
					</div>
					{invoice.custom_fields?.map((customField) => {
						const { id, slug, value } = customField;
						const customFieldConfig = customFieldsConfig?.find(
							(currentCustomField) => currentCustomField.slug === slug
						);
						let name = "";
						if (customFieldConfig) {
							name = customFieldConfig.name;
						}
						return (
							<div key={id} className="col-md-4 mt-sm-2 mt-0">
								<div className="card-body-item text-truncate">
									<div className="item-info text-truncate">
										<span className="label">{name}</span>
										<span className="text-truncate" title={value}>
											{value}
										</span>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</Card.Body>
		</Card>
	);
};

export default InvoicePreviewBasicInfoCard;

// t(`enums.invoices.calculation_type.NET`)
// t(`enums.invoices.calculation_type.GROSS`)
